import axios from 'axios';

const DATOCMS_API_TOKEN = import.meta.env.VITE_DATOCMS_API_TOKEN;

if (!DATOCMS_API_TOKEN) {
  throw new Error('Missing DatoCMS API token');
}

const client = axios.create({
  baseURL: 'https://graphql.datocms.com',
  headers: {
    'Authorization': `Bearer ${DATOCMS_API_TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export interface CreatorVideo {
  id: string;
  src: string;
  title?: string;
  thumbnail?: string;
  fullVideoUrl?: string;
  gifPreview?: string;
}

export const getCreatorVideos = async (): Promise<CreatorVideo[]> => {
  try {
    const response = await client.post('', {
      query: `
        query MyQuery {
          videolibrary {
            id
            library {
              url
              id
              video {
                mp4Url(res: medium)
                muxPlaybackId
                thumbnailUrl(format: gif)
              }
            }
          }
        }
      `
    });

    // Check if we have the expected data structure
    if (response.data?.data?.videolibrary?.library) {
      return response.data.data.videolibrary.library.map((item: { url: string, id: string, video?: { mp4Url: string, muxPlaybackId?: string, thumbnailUrl?: string } }, index: number) => ({
        id: item.id,
        src: item.video?.mp4Url,
        title: `Video ${index + 1}`,
        thumbnail: item.video?.thumbnailUrl,
        gifPreview: item.video?.thumbnailUrl
      }));
    }

    return [];
  } catch (error) {
    console.error('Error fetching creator videos:', error);
    return [];
  }
};

export const getFullVideo = async (videoId: string): Promise<CreatorVideo | null> => {
  try {
    const response = await client.post('', {
      query: `
        query MyQuery {
          allUploads(filter: {id: {eq: "${videoId}"}}) {
            url
            id
            video {
              thumbnailUrl
              streamingUrl
              mp4Url(res: medium)
            }
          }
        }
      `
    });

    if (response.data?.data?.allUploads?.[0]) {
      const video = response.data.data.allUploads[0];
      return {
        id: video.id,
        src: video.video?.mp4Url || video.url,
        thumbnail: video.video?.thumbnailUrl,
        fullVideoUrl: video.video?.mp4Url,
        gifPreview: video.video?.thumbnailUrl
      };
    }

    return null;
  } catch (error) {
    console.error('Error fetching full video:', error);
    return null;
  }
}; 